export default "__VITE_ASSET__fcbd382d__"